import { useCallback, useState } from "react";
import { useGetCurrenciesQuery } from "../../features/trade&coins/coinSlice";
import { CURRENCIES, DisplayCurrency, formatMoney, nextCurrency, Rate } from "../../lib/leaderboard/format";

const KEY = "leaderboard_currency";
const read = (): DisplayCurrency => {
  try {
    const v = localStorage.getItem(KEY);
    return v && (CURRENCIES as string[]).includes(v) ? (v as DisplayCurrency) : "ngn";
  } catch {
    return "ngn";
  }
};

/** Per-browser display currency for prize amounts (NGN stored; GHS/USD via the admin rates). */
export const useDisplayCurrency = () => {
  const [currency, setCurrency] = useState<DisplayCurrency>(read);
  const { data: rates } = useGetCurrenciesQuery();
  const cycle = useCallback(() => {
    setCurrency((c) => {
      const n = nextCurrency(c);
      try { localStorage.setItem(KEY, n); } catch { /* private mode */ }
      return n;
    });
  }, []);
  const money = useCallback((ngn: number) => formatMoney(ngn, currency, rates as Rate[] | undefined), [currency, rates]);
  return { currency, cycle, money };
};
